var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.isDateSupported = new function () {
    var self = this;
    this.init = function () {
        var dateTimeFields = $("input[type=date], input[type=time]");
        if (!dateTimeFields.length) return;

        var isDateSupported = function () {
            var input = document.createElement('input');
            var value = 'a';
            input.setAttribute('type', 'date');
            input.setAttribute('value', value);
            return (input.value !== value);
        };

        // Load a fallback when input[type="date"] is not supported
        if (!isDateSupported()) {
            loadJS('/dist/scripts/datepicker-polyfill.min.js');
        } else {
            for (var i = 0; i < dateTimeFields.length; i++) {
                var input = dateTimeFields[i];
                if (input.nextElementSibling) {
                    input.nextElementSibling.classList.add('issupported');

                }
            }
        }
    };
}();
